import { combineReducers } from 'redux';
import {
    BookmarkFetchSuccessActionType,
    BookmarkFetchRequestActionType,
    BookmarkFetchFailureActionType,
    BookmarkCreateSuccessActionType,
    BookmarkDeleteSuccessActionType,

} from '../Bookmark/bookmarkAction';
import { ActionType } from 'store/ActionType';
import { BookmarkResponse } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const items = (state: Nullable<BookmarkResponse[]> = null, action: ActionType) => {
    switch (action.type) {
        case BookmarkFetchSuccessActionType:
            {
                return action.payload;
            }
        case BookmarkCreateSuccessActionType:
            {
                if (action.payload && action.payload.id) {
                    const newBookmark: BookmarkResponse = {
                        id: action.payload?.id,
                        referenceId: action.payload?.referenceId,
                        origin: action.payload?.origin,
                        pageUrl: action.payload?.pageUrl,
                        title: action.payload?.title,
                        beginDate: action.payload?.beginDate,
                        icId: action.payload?.icId,
                        initials: action.payload?.initials,
                    };

                    return [...(state || []), newBookmark];
                }

                return state;
            }
        case BookmarkDeleteSuccessActionType:
            {
                if (action.payload > 0) {
                    return (state || []).filter(b => b.id !== action.payload);
                }

                return state;
            }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case BookmarkFetchRequestActionType: {
            return true;
        }
        case BookmarkFetchFailureActionType:
        case BookmarkFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    items,
    isLoading,
});
